import Swiper from "swiper";
import { Pagination } from "swiper/modules";

export default class InfoCardsCarousel {
	constructor(block) {
		this.block = block;
		this.swiperWrapper = this.block.querySelector(".swiper");
		this.pagination = this.block.querySelector(".swiper-pagination");
		if (!this.swiperWrapper) return;
		this.swiper = this.initSwiper();
	}
	
	initSwiper() {
		const args = {
			slidesPerView: 1.25,
			spaceBetween: 32,
			speed: 500,
			modules: [Pagination],
			breakpoints: {
				768: { slidesPerView: 2, slidesPerGroup: 2 },
				992: { slidesPerView: 3, slidesPerGroup: 3 },
			},
		};
		if (this.pagination) {
			args.pagination = {
				el: this.pagination,
				clickable: true,
				type: "bullets",
			};
		}
		return new Swiper(this.swiperWrapper, args);
	}
}
